 import { connect } from 'react-redux';
 import AllPercComp from '../Components/AllPercComp';
  
 
const mapStateToProps = state => ({
    allPerc: state.Fs
})

 

 


export default connect(mapStateToProps, null)(AllPercComp);